import GeneralIcon from '@material-ui/icons/Storage';

export default {
  icon: GeneralIcon,
}